import { Component, Inject, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import { ScorecardDataService } from '../core/data.service';
import { Widget, WidgetType } from '../core/template-definition.model';
import { TranslationKeyMap } from '../scorecard.i18n';
import { CMPS_SCORECARD_WIDGET } from '../scorecard.metadata';
import { CompensationQualifier } from '../scorecard.model';

@Component({
    selector: 'cmps-scorecard-compensation-qualifier-widget',
    templateUrl: './comp-qualifier-widget.component.html',
})
@TakeUntilDestroy()
export class ScCompQualifiersWidgetComponent implements OnDestroy {
    /** @private */ _compensationQualifiers: CompensationQualifier[];
    /** @private */ _compensationQualifierCondition: CompensationQualifier;

    testDataAllQualifiersMet: boolean = false;

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _collapsed: boolean;

    /** @private */ get _isLoadingData(): Observable<boolean> {
        return this._loadingData.asObservable();
    }

    private readonly _loadingData: BehaviorSubject<boolean>;

    public headerColour: string;
    public headerTextColour: string;

    constructor(
        private readonly _dataService: ScorecardDataService,
        @Inject(CMPS_SCORECARD_WIDGET) /** @private */ public _widget: Widget,
    ) {
        this.headerColour = _widget.headerColour;
        this.headerTextColour = _widget.headerTextColour;
        this._loadingData = new BehaviorSubject<boolean>(false);
    }

    ngOnInit(): void {
        this._dataService
            .observableForWidgetType<CompensationQualifier[]>(
                WidgetType.COMPENSATION_QUALIFIERS,
            )
            .pipe(
                tap((data) => {
                    const dat = data || [];
                    this._compensationQualifiers = dat.filter(
                        (x) => !x.isQualificationCondition,
                    );
                    this._compensationQualifierCondition = dat.find(
                        (e) => e.isQualificationCondition,
                    );
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        //
    }
}
